(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.InstagramPrivateStoryFrame = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Instagram private story frame data',
            channelName: sourceDetails[sources.INSTAGRAM_INSIGHTS].name,
            postName: sourceDetails[sources.INSTAGRAM_INSIGHTS].postName,

            storageDimensions: [
                'story_frame_id'
            ],

            fields: {
                story_frame_id: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    dataType: dataType.STRING
                },
                presence_reach: {
                    dataType: dataType.INTEGER
                },
                published_at: {
                    dataType: dataType.DATE
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                message: {
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                frame_order: {
                    dataType: dataType.INTEGER
                },
                frame_reach: {
                    dataType: dataType.INTEGER
                },
                impressions: {
                    dataType: dataType.INTEGER
                },
                replies: {
                    dataType: dataType.INTEGER
                },
                exits: {
                    dataType: dataType.INTEGER
                },
                exit_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                full_view_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                taps_forward: {
                    dataType: dataType.INTEGER
                },
                taps_backward: {
                    dataType: dataType.INTEGER
                },
                swipes_forward: {
                    dataType: dataType.INTEGER
                },
                completion_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                taps_forward_rate_by_impression: {
                    dataType: dataType.INTEGER
                },
                reach_rate_by_presence_reach: {
                    dataType: dataType.INTEGER
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                follows: {
                    dataType: dataType.INTEGER
                },
                profile_views: {
                    dataType: dataType.INTEGER
                },
                profile_interactions: {
                    dataType: dataType.INTEGER
                },
                profile_bio_link_clicks: {
                    dataType: dataType.INTEGER
                },
                profile_other_interactions: {
                    dataType: dataType.INTEGER
                },
                media_type: {
                    dataType: dataType.STRING
                },
                thumbnail_url: {
                    dataType: dataType.STRING
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
